export default function dateToUTC(date) {
  return date.toISOString();
}
